<template>
    <rkm-form
        ref="RkmForm"
        show-legend
    >
        <rkm-overlay :show="loading">
            <rkm-row>
                <rkm-col>
                    <rkm-form-input
                        :validations="validations.nome"
                        label="Nome"
                        uppercase
                        v-model="model.nome"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-overlay>
    </rkm-form>
</template>

<script>
// Mixins.
import {error} from '@/mixins'

// Vuex.
import {mapActions, mapGetters} from 'vuex'

export default {
    computed: {
        ...mapGetters(['getLoading']),
        loading() {
            return this.getLoading('cadastro-convenio-odontologico-form')
        },
        validations() {
            return {
                nome: {
                    required: true,
                    min: 3,
                    max: 100,
                },
            }
        },
    },
    data: () => ({
        model: {
            nome: null,
        },
    }),
    inject: ['repositories'],
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            if (this.id) {
                this.setLoading('cadastro-convenio-odontologico-form')

                this.repositories.cadastro.convenioOdontologico.edit(this.id)
                    .then(({ data }) => this.model.nome = data.model.nome)
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading('cadastro-convenio-odontologico-form'))
            }
        },
        save() {
            this.$refs.RkmForm.validate()
                .then(validated => {
                    if (validated) {
                        this.setLoading('cadastro-convenio-odontologico-form')

                        const request = {
                            nome: this.model.nome,
                        }

                        if (this.id) {
                            this.repositories.cadastro.convenioOdontologico.update(request, this.id)
                                .then(({ data }) => this.$emit('save', data))
                                .catch(this.handleError)
                                .finally(() => this.unsetLoading('cadastro-convenio-odontologico-form'))
                        } else {
                            this.repositories.cadastro.convenioOdontologico.store(request)
                                .then(({ data }) => this.$emit('save', data))
                                .catch(this.handleError)
                                .finally(() => this.unsetLoading('cadastro-convenio-odontologico-form'))
                        }
                    }
                })
        },
    },
    mixins: [error],
    mounted() {
        this.load()
    },
    props: {
        id: { type: Number },
    },
}
</script>